import React from "react";
import "./PageSideBarTop.scss";

const PageSideBarTop = (props) => {
  return (
    <div className="page-sidebar-top">
      <i className="app-icon"></i>
      {!!props.appName ? props.appName : <span className="app-name"></span>}
    </div>
  );
};

export default PageSideBarTop;
